var map = {
	"./tapcoin/lucky/lucky-result-coin-tapcoins.png": 16414,
	"./tapcoin/lucky/lucky-result-coin-ton.png": 82649,
	"./tapcoin/lucky/lucky-result-coin-usdt.png": 11104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72541;